import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { Alert } from '@storable/canaveral-components';
import FormFieldLabelTooltip from '../FormFieldLabelTooltip';
import FacilitySelect from '../../containers/FacilitySelect';
import FacilityEdit from '../../containers/FacilityEdit';
import styles from './styles.scss';

const PRIMARY_IMAGE_SECTION_NAME = 'primary';
const FACILIITY_LOGO_SECTION_NAME = 'logo';

const propTypes = {
  facility: PropTypes.shape({
    label: PropTypes.shape({
      props: PropTypes.shape({
        facility: PropTypes.shape({
          linkOutUrl: PropTypes.string,
        }),
      }),
    }),
    value: PropTypes.string,
  }),
  setFacility: PropTypes.func.isRequired,
  setAppliedMedia: PropTypes.func.isRequired,
};
const defaultProps = {
  facility: null,
};

const FacilityBrandingForm = ({
  facility,
  setFacility,
  setAppliedMedia,
  ...rest
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitErrors, setSubmitErrors] = useState(null);

  const handleFacilitySelect = (selectedFacility) => {
    setFacility(selectedFacility);
    setAppliedMedia(FACILIITY_LOGO_SECTION_NAME, null);
    setAppliedMedia(PRIMARY_IMAGE_SECTION_NAME, null);
  };

  return (
    <>
      {submitted && (
        <Alert context="success" className={styles.alert}>
            Facility branding successfully saved
        </Alert>
      )}
      {!submitting && submitErrors && (
        <Alert context="danger" className={styles.alert}>
          {submitErrors.map(updateError => (
            <div key={updateError.code}>
              {updateError.message}
            </div>
          ))}
        </Alert>
      )}
      <Row className={styles.dropdownRow}>
        <Col xs={12} className={styles.dropdownTitle}>
          <span>Facility</span>
        </Col>
        <Col xs={10} className={styles.dropdownCol}>
          <FacilitySelect
            name="facilityId"
            label="Facility"
            showDisabled
            onChange={option => handleFacilitySelect(option)}
            value={facility}
            className={styles.dropdown}
            scopeToUser
          />
        </Col>
        {facility && facility.label.props.facility.linkOutUrl
          && (
          <Col xs={2} className={styles.tooltip}>
            <span className={styles.text}>Link Out</span>
            <FormFieldLabelTooltip
              text="This facility doesn't have a page associated with it."
            />
          </Col>
          )
        }
      </Row>
      {facility
        && (
        <Row>
          <Col xs={12}>
            <FacilityEdit
              {...rest}
              facilityId={facility.value}
              setAppliedMedia={setAppliedMedia}
              setSubmitting={setSubmitting}
              setSubmitted={setSubmitted}
              setSubmitErrors={setSubmitErrors}
            />
          </Col>
        </Row>
        )
      }
    </>
  );
};

FacilityBrandingForm.propTypes = propTypes;
FacilityBrandingForm.defaultProps = defaultProps;

export default FacilityBrandingForm;
